module.exports = __webpack_public_path__ + "static/media/Dual_4431.a2732d28.jpg";